import { render, staticRenderFns } from "./SearchPopup.vue?vue&type=template&id=22a4801f"
import script from "./SearchPopup.vue?vue&type=script&lang=js"
export * from "./SearchPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports